<ion-item [disabled]="locked">

  <ion-thumbnail slot="start">
    <img [src]="item.foto || 'assets/img/empty-img/no_image.png'" alt=""/>

    @if (item.needs_revision) {
      <div class="icon-title-wrapper icon-background warning">
        <yu-icon color="light" name="warning-circle"></yu-icon>
      </div>
    }
  </ion-thumbnail>

  <ion-label>

    <div class="title">{{ item.nombre }}</div>

    @if (item.referencia || item.descripcion_compra) {
      <div class="description info">

        @if (item.referencia) {
          <span>#{{ item.referencia }}</span>
        }

        @if (item.descripcion_compra) {
          <span>{{ item.referencia ? ' | ' : '' }}{{ item.descripcion_compra }}</span>
        }

      </div>
    }

    <div class="description">
      @if (data.should_see_price_by_provider_context && permissionsManager.checkPermission('precios', 'ver')) {
        {{ item.precio_final | currency: 'EUR': 'symbol': '1.2-2': 'es' }} /
      }

      {{ item.formato_ver }}
    </div>

    <div class="description data">

      @if (item.formato_multiplo) {
        <span>{{ 'PURCHASES.ORDERS.DETAIL.PACK' | translate }}: {{ item.formato_multiplo | number: '1.0-2' }}</span>
      }

      @if (item.formato_minimo) {
        <span>{{ 'PURCHASES.ORDERS.DETAIL.MIN' | translate }}: {{ item.formato_minimo | number: '1.0-2' }}</span>
      }

      @if (item.peso_bruto) {
        <span>{{ 'PURCHASES.ORDERS.DETAIL.WEIGHT_KG' | translate }}: {{ item.peso_bruto | number: '1.0-2' }} KG</span>
      }

    </div>

    @if (item.num_promo_multiplo) {
      <yu-helper color="info" icon="warning-circle">{{ 'PURCHASES.ORDERS.DETAIL.PROMOTION' | translate }}: {{ item.num_promo_multiplo }}+1</yu-helper>
    }

    @if (!item.precio_mejor && item.precio_mejor_ && data.should_see_price_by_provider_context && permissionsManager.checkPermission('precios', 'ver')) {
      <yu-helper color="success" icon="warning-circle">
        {{ 'PURCHASES.ORDERS.DETAIL.BEST_PRICE' | translate }}: {{ item.precio_mejor_ | currency: 'EUR':'symbol':'1.2-2':'es' }}/{{ item.unidad }}
      </yu-helper>
    }

  </ion-label>

  <ion-note class="info-note" slot="end">

    @if (item.needs_revision) {

      <yu-button
        size="small"
        color="warning"
        (yuClick)="configureClick.emit()"
      >
        Configurar
      </yu-button>

    } @else {

      <app-counter-input
        [min]="item.formato_minimo"
        [multiple]="item.formato_multiplo"
        [onlyNegative]="onlyNegativeQuantity"
        [(value)]="item.cantidad"
        (valueChange)="itemChange.emit(item)"
      ></app-counter-input>

      @if (item.formato_multiplo && item.cantidad) {
        <p>
          {{ (item.cantidad / item.formato_multiplo) | number: (item.formato_multiplo < 1 ? '1.0-0' : '1.0-2') }} x {{ item.formato_multiplo_label || ('PURCHASES.ORDERS.DETAIL.PACK' | translate) }}
        </p>
      }

      @if (item.stocks) {

        <div class="stocks">

          @if (item.stocks.min && item.stocks.max) {
            <p>min: {{ item.stocks.min.today || '-' }} | max: {{ item.stocks.max.today || '-' }}</p>
          }

          @if (item.stocks.cantidad) {
            <p>{{ 'PURCHASES.ORDERS.DETAIL.STOCK' | translate }}: {{ item.stocks.cantidad | number:'1.0-2' }} {{ item.unidad }}</p>
          }

        </div>

      }

    }

  </ion-note>

</ion-item>
